export default __webpack_public_path__ + "static/media/mundo_facens_metro.f9277712.wav";